import { useAppStore } from '@store'
import { Getter, Setter, Store } from '@types'

export function t(
  set: Setter,
  get: Getter,
  str: number | keyof Store['textos']['textos'] | string,
): string {
  const textos = useAppStore((store) => store.textos)

  if (!textos.textos) return str
  if (!(str in textos.textos)) return str
  if (!str) return ''
  //TODO: check once again this shit property access
  return textos.textos[str]
}

export async function setTextos(get: Getter, set: Setter, textos: Store['textos']) {
  set((store) => {
    store.textos = textos
  })
}
